(function () {
  'use strict';

  if (window.FellinoraWetfoodBenefitsLoaded) {
    return;
  }

  window.FellinoraWetfoodBenefitsLoaded = true;

  var sections = [];
  var frame = null;
  var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var motionStates = new WeakMap();

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function lerp(current, target, amount) {
    return current + (target - current) * amount;
  }

  function clearMotion(section) {
    section.removeAttribute('data-fwb-motion-ready');
    motionStates.delete(section);
    section.querySelectorAll('[data-fwb-card]').forEach(function (card) {
      card.style.removeProperty('--fwb-front-rotate');
      card.style.removeProperty('--fwb-front-translate-x');
      card.style.removeProperty('--fwb-front-translate-y');
      card.style.removeProperty('--fwb-front-scale');
      card.style.removeProperty('--fwb-front-opacity');
      card.style.removeProperty('--fwb-back-rotate');
      card.style.removeProperty('--fwb-back-scale');
    });
  }

  function updateSection(section) {
    var rect = section.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    var strength = Number(section.getAttribute('data-motion-strength'));
    var motionStrength = Number.isFinite(strength) ? strength : 1;

    if (motionStrength <= 0) {
      clearMotion(section);
      return false;
    }

    if (rect.bottom < -viewportHeight * 0.25 || rect.top > viewportHeight * 1.25) {
      section.removeAttribute('data-fwb-motion-ready');
      return false;
    }

    var swapProgress;

    if (window.innerWidth < 750) {
      var visual = section.querySelector('.fwb__visual-frame');
      var visualTop = visual ? visual.getBoundingClientRect().top : rect.top;
      var animationStart = viewportHeight * 0.88;
      var animationDistance = viewportHeight * 0.42;

      // On mobile the copy makes the section much taller than the viewport.
      // Tie the swap to the image itself so it happens while the circle is visible.
      swapProgress = clamp((animationStart - visualTop) / animationDistance, 0, 1);
    } else {
      var fullyVisibleTop = Math.max(0, viewportHeight - rect.height);
      var scrollAfterFullyVisible = fullyVisibleTop - rect.top;
      swapProgress = clamp(scrollAfterFullyVisible / 90, 0, 1);
    }

    var easedSwap = swapProgress * swapProgress * (3 - 2 * swapProgress);
    var front = section.querySelector('[data-fwb-card="front"]');
    var back = section.querySelector('[data-fwb-card="back"]');

    if (!front || !back) {
      return false;
    }

    section.setAttribute('data-fwb-motion-ready', 'true');

    var targets = {
      frontRotate: easedSwap * 126 * motionStrength,
      frontX: easedSwap * 3 * motionStrength,
      frontY: easedSwap * -1.5 * motionStrength,
      frontScale: 1 - easedSwap * 0.14 * motionStrength,
      frontOpacity: 1 - easedSwap,
      backRotate: -3 + easedSwap * 7 * motionStrength,
      backScale: 0.97 + easedSwap * 0.03
    };
    var state = motionStates.get(section);

    if (!state) {
      state = Object.assign({}, targets);
      motionStates.set(section, state);
    } else {
      state.frontRotate = lerp(state.frontRotate, targets.frontRotate, 0.22);
      state.frontX = lerp(state.frontX, targets.frontX, 0.22);
      state.frontY = lerp(state.frontY, targets.frontY, 0.22);
      state.frontScale = lerp(state.frontScale, targets.frontScale, 0.22);
      state.frontOpacity = lerp(state.frontOpacity, targets.frontOpacity, 0.28);
      state.backRotate = lerp(state.backRotate, targets.backRotate, 0.2);
      state.backScale = lerp(state.backScale, targets.backScale, 0.2);
    }

    front.style.setProperty('--fwb-front-rotate', state.frontRotate.toFixed(3) + 'deg');
    front.style.setProperty('--fwb-front-translate-x', state.frontX.toFixed(3) + '%');
    front.style.setProperty('--fwb-front-translate-y', state.frontY.toFixed(3) + '%');
    front.style.setProperty('--fwb-front-scale', state.frontScale.toFixed(4));
    front.style.setProperty('--fwb-front-opacity', state.frontOpacity.toFixed(4));

    back.style.setProperty('--fwb-back-rotate', state.backRotate.toFixed(3) + 'deg');
    back.style.setProperty('--fwb-back-scale', state.backScale.toFixed(4));

    return (
      Math.abs(state.frontRotate - targets.frontRotate) > 0.04 ||
      Math.abs(state.frontX - targets.frontX) > 0.01 ||
      Math.abs(state.frontY - targets.frontY) > 0.01 ||
      Math.abs(state.frontScale - targets.frontScale) > 0.0005 ||
      Math.abs(state.frontOpacity - targets.frontOpacity) > 0.002 ||
      Math.abs(state.backRotate - targets.backRotate) > 0.02 ||
      Math.abs(state.backScale - targets.backScale) > 0.0005
    );
  }

  function update() {
    frame = null;
    sections = sections.filter(function (section) {
      return section.isConnected;
    });

    if (motionQuery.matches) {
      sections.forEach(clearMotion);
      return;
    }

    var isAnimating = false;

    sections.forEach(function (section) {
      if (updateSection(section)) {
        isAnimating = true;
      }
    });

    if (isAnimating) {
      frame = window.requestAnimationFrame(update);
    }
  }

  function requestUpdate() {
    if (frame === null) {
      frame = window.requestAnimationFrame(update);
    }
  }

  function initSection(section) {
    if (!section || section.hasAttribute('data-fwb-initialized')) {
      return;
    }

    section.setAttribute('data-fwb-initialized', 'true');
    sections.push(section);
    requestUpdate();
  }

  function init(root) {
    if (root.matches && root.matches('[data-fwb-section]')) {
      initSection(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll('[data-fwb-section]').forEach(initSection);
    }
  }

  function handleMotionPreference() {
    sections.forEach(clearMotion);
    requestUpdate();
  }

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });

  if (motionQuery.addEventListener) {
    motionQuery.addEventListener('change', handleMotionPreference);
  } else if (motionQuery.addListener) {
    motionQuery.addListener(handleMotionPreference);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    }, { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var removedSection = event.target.matches('[data-fwb-section]')
      ? event.target
      : event.target.querySelector('[data-fwb-section]');

    if (!removedSection) {
      return;
    }

    sections = sections.filter(function (section) {
      return section !== removedSection;
    });
  });
})();
